/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* vastpersoneel.ts
* 14-1-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Datatablescherm} from '../../abstracts/datatablescherm.class';
import {Component} from '@angular/core';
import {DatatableDef} from 'sihw-ng/datatable/datatable.component';
import {Datarecords} from '../../../services/api/api.service';
import {Personeel} from '../../../models/personeel';
import {Leverancier} from '../../../models/leverancier';

@Component({
  selector: 'scherm-vastpersoneel',
  templateUrl: './vastpersoneel.html',
  // styleUrls: ['./vastpersoneel.scss']
})
export class Vastpersoneelscherm extends Datatablescherm {
  _starttitle = 'Personeel';
  icon = 'fas fa-people-carry';

  editscherm = 'Vastpersoneeledit';
  model = Personeel;
  //query nog op oude manier
  tableQuery = {
    table: 'personeelvast',
    connected: [
      {
        //alle functies, niet alleen de hoofdfunctie: we kijken ook naar de einddatums van de certificering
        table: 'personeelvast_functie',
        required: false,
        connected: [{
          table: 'functie',
          attributes: ['id', 'naam', 'kleur'] //niet via lookup, want we willen ook functies die niet kloppen toch tonen
        }]
      },
      {
        table: 'personeelvast_label'
      }
    ]
  };

//////////////////////////// tabledef
  public readonly tableDefinition: DatatableDef = {
    track: 'id',
    standaardsortering: {
      key: 'naam',
      richting: 1
    },
    //personeel met een verlopen certificering valt op, met de uitleg in de tooltip van de rij
    rijclasses: (persoon: Personeel) => persoon.certificeringVerlopen() ? ['certificering_verlopen'] : [],
    rijtitle: (persoon: Personeel) => persoon.certificeringmeldingen().join('\n'),
    velden: {
      naam: {
        label: 'Naam',
        prop: 'naam',
        type: 'string'
      },
      groep: {
        label: 'Groep',
        type: 'enum'
      },
      woonplaats: {
        label: 'Woonplaats',
        type: 'enum'
      },
      telefoonnummer: {
        label: 'Tel'
      },
      leverancier: {
        prop: '_tags.leverancier.naam',
        type: 'enum',
        label: 'Leverancier'
      },
      nummer: {
        label: 'Nr'
      },
      functiekleur: {
        label: null,
        prop: '_tags.hoofdfunctie.kleur',
        filter: false,
        html: true,
        format: kleur => kleur ? `<div class="text-center"><span class='kleur' style="background-color: ${kleur};"></span></div>` : ''
      },
      functie: {
        label: 'Hoofdfunctie',
        prop: '_tags.hoofdfunctie.naam'
      },
      certificering: {
        label: 'Certificering',
        //een vinkje betekent hier, net als bij de andere janeevelden, dat het in orde is
        prop: (persoon: Personeel) => !persoon.certificeringVerlopen(),
        type: 'bool'
      },
      actief: {
        label: 'Inzetbaar',
        type: 'bool',
        standaardfilter: 1
      },
      inlog_actief: {
        label: 'Inloggen',
        type: 'bool'
      }
    }
  };

//constructor
  constructor() {
    super('debug');
  }

  //data aanpassen na ophalen
  protected async dataGetter(): Promise<Datarecords> {
    let res = <Personeel[]> await super.dataGetter();
    let leveranciers = await Leverancier.getLookup(Personeel);
    if (res) {
      for (let persoon of res) {
        //we halen alle functies op, dus we zoeken de hoofdfunctie erbij
        persoon._tags.hoofdfunctie = persoon.personeel_functie?.find(pf => pf.hoofdfunctie)?.functie;
        persoon._tags.leverancier = persoon.leverancier_id && leveranciers[persoon.leverancier_id];
      }
    }
    this.log.debug(res);
    return res;
  }
}
